module.exports = __webpack_public_path__ + "img/115.36b40b3b.svg";